<div class="act-sync-ftc-container">
  <div class="paddingTop">
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label>Dropdown</label>
        <select class="form-control" [(ngModel)]="actSyncFtcData.dropdown">
          <option value="">Select</option>
          @for (x of names; track $index) {
<option [value]="x">{{ x }}</option>
}
        </select>
      </div>
      <div class="form-group col-sm-4">
        <label>System Account key</label>
        <input type="text" class="form-control" placeholder="Enter System Account Key" [(ngModel)]="actSyncFtcData.sysActKey" />
      </div>
      <div class="form-group col-sm-4">
        <label>Alt Gie key</label>
        <input type="text" class="form-control" placeholder="Enter Alt Gie Key" [(ngModel)]="actSyncFtcData.gieKey" />
      </div>
    </div>
    <div class="save-row">
      <button type="button" class="save-button" [disabled]="isSaveClicked" (click)="save()">
        @if (showJsonLoader) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
    </div>
  </div>
</div>
